module.exports = __webpack_public_path__ + "static/media/3.db1055d8.jpg";